import axios from "@/plugins/axios";
import { actionTypes, mutationTypes } from "./types";
export const actions = {
    async [actionTypes.getValidationResult]({ commit }, { id = null, force = null }) {
        commit(mutationTypes.adstxtValidationStart);
        /* const url = "https://apu.performax.cz/problems/ads.txt?agency_id=10&domain=" + domain;

        const response = await fetch(url);
        if (!response.ok) {
            const errorData = await response.json();
            console.error("Error loading data: " + JSON.stringify(errorData));
            commit(mutationTypes.adstxtValidationFailure, errorData.description || "Error loading data");
            return;
        }
        const data = await response.json();
        commit(mutationTypes.adstxtValidationSuccess, data);
        */
        let url = "sql/ads_txt";
        if (id) {
            url += "/" + id;
        }
        let method = "get";
        if (force) {
            method = "post";
        }
        return axios({
            method: method,
            url: url,
        }).then(
            ({ data }) => {
                console.log(data);
                commit(mutationTypes.adstxtValidationSuccess, data);
            },
            () => {
                commit(mutationTypes.adstxtValidationFailure, "Error loading data");
            }
        );
    },
};
